/**
 * Pan cancer card component
 */
import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormHandlerService} from '@ispm/dynamic-form/services/form-handler.service';
import {Widget} from '@ispm/widgets/decorator/widget.decorator';
import {IWidgetItem} from '@ispm/widgets/interfaces/widget-item.interface';
import {IdynamicFormItem} from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import {filter, finalize, map, take, takeUntil} from 'rxjs/operators';
import {fill, findIndex, get, has, includes, isEmpty, set} from 'lodash';
import {DynamicFormItem} from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import {ITEMS_TYPES} from '@ispm/dynamic-form/constants/ItemsTypes';
import {PanCancerDynamicFormModalComponent} from '@ispm-client/modules/pan-cancer/components/pan-cancer-dynamic-form-modal/pan-cancer-dynamic-form-modal.component';
import {ModalTypes} from '@ispm/layout/components/modals/contants/modal-types.enum';
import {PlaceholderModalComponent} from '@ispm/layout/components/modals/placeholder-modal/placeholder-modal.component';
import {PlaceholderModalLoaderPayload} from '@ispm/layout/classes/placeholder-modal-loader-payload';
import {DynamicModalLoaderService} from '@ispm/layout/services/dynamic-modal-loader.service';
import {PermissionSchemaConstants} from '@ispm/shared/constants/permission-schema.constants';
import {BUTTON_ACTIONS} from './constants/constant';
import {AgregationService} from '@ispm-client/modules/aggregator/services/aggregator.service';
import {CARD_ACTIONS, constants} from "@ispm-client/modules/pan-cancer/constants/constants";
import {TimelineService} from "@ispm-client/modules/timeline/services/timeline.service";
import {IQueryParam} from "@ispm-client/modules/events/Interfaces";
import {InterpolateService} from '@ispm/shared/services/interpolate.service';
import {RouterManagerService} from '@ispm/core/services/router-manager.service';
import {EventService} from '@ispm-client/modules/events/services/event.service';
import {WorkflowUtilService} from '@ispm-client/modules/aggregator/services/workflow-util.service';
import {Subject} from 'rxjs';
import {AuthenticationService} from '@ispm/user/services/authentication.service';
import {Router} from "@angular/router";


@Component({
  selector: 'ispm-pan-cancer-card',
  templateUrl: './pan-cancer-card.component.html',
  styleUrls: ['./pan-cancer-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('PanCancerCard')
export class PanCancerCardComponent implements OnInit, OnDestroy, IWidgetItem {
  @Input() payload;
  patientId;
  viewForms;
  editForms;
  data;
  isEditMode: boolean = false;
  editFormIdOrConfig;
  viewFormIdOrConfig;
  showFormIdOrConfig;
  load: boolean = true;
  actionItems;
  showAllForms;
  showAllDataCountValue: number;
  showAllDataCountIconPath = constants.exclamationImagePath;
  private permitPanCancerWrite: boolean;
   buttonSubmitted: boolean = false;
  showEditIcon: boolean = true;
  eventData:any;
  public dataRecieved: boolean[] = [];
  public isdataRecieved: boolean = false;
  private destroyed$: Subject<any> = new Subject<any>();

  public ModalLoaderTunnelName = 'PANCANCER_MODAL_LOADER_CHANNEL';
  public ModalLoaderTunnelNameEdit = 'PANCANCER_EDIT_MODAL_LOADER_CHANNEL';
  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this.payload = _itemConfig;
  }

  set widgetData(widgetData: any) {
    this.data = widgetData;
  }

  constructor(private _formHandler: FormHandlerService,
              private modalLoader: DynamicModalLoaderService,
              private workflowUtilService: WorkflowUtilService,
              private authService: AuthenticationService,
              private _agregationService: AgregationService,
              private timelineService: TimelineService,
              private _interpolateService: InterpolateService,
              private _routerManagerService: RouterManagerService,
              private _eventService: EventService,
              private routerManagerService: RouterManagerService,
              private router: Router) {
  }

  ngOnInit() {
    this.patientId = this.routerManagerService.parameters.patientId;
    this.viewForms = this.payload.widgetPayload.viewForms;
    if(isEmpty(this.viewForms)){
      this.isdataRecieved = true;
    }
    this.dataRecieved = fill(Array(this.viewForms.length), false); // TODO do this only for forms with databinding
    this.showAllForms = this.payload.widgetPayload.showAllForms;
    this.editForms = this.payload.widgetPayload.editForms;
    this.actionItems = this.payload.widgetPayload.actions;
    const filterActionByEvent = this.actionItems.filter(action => action.type === BUTTON_ACTIONS.EVENT_PANEL);
    if(filterActionByEvent && filterActionByEvent[0]) {
      this.showOrHideEventIcon(filterActionByEvent[0]);
    }
    this.buildFormConfigurationFromFields();
    this.permitPanCancerWrite = this.authService.doesUserHasPermission(PermissionSchemaConstants.getPermissionSchema('panCancerDashboardWrite'));

    if (get(this.payload, 'widgetPayload.permitOnlyAssignee', false)) {
      this.workflowUtilService.checkIfPerformer()
          .pipe(
              takeUntil(this.destroyed$)
          )
          .subscribe((isPerformer: boolean) => {
            this.permitPanCancerWrite = isPerformer;
          });
    }
    // Forms prefetching
    if(!isEmpty(this.editForms) &&  (Array.isArray(this.editForms))) {
      this.editForms.forEach(field => {
        this._formHandler.getForm(field['formId']);
      });
    }
    if(!isEmpty(this.showAllForms) && (Array.isArray(this.showAllForms) )) {
      this.showAllForms.forEach(field => {
        this._formHandler.getForm(field['formId']);
      });
    }
  }

  performAction(action){
    switch (action.type) {
      case BUTTON_ACTIONS.EDIT_MODE:
        this.showEditMode();
        break;
      case BUTTON_ACTIONS.SHOW_ALL_MODE:
        this.showAllModal();
        break;
      case BUTTON_ACTIONS.CONTEXT_LAUNCH:
        this.contextLaunch(action);
        break;
      case BUTTON_ACTIONS.EVENT_PANEL:
        this.navigateToEvent(this.eventData);
        break;
      case BUTTON_ACTIONS.NAVIGATE_URL:
        this.navigateToUrl(action);
        break;
    }
  }

  showEditMode() {
    this.isEditMode =  true;
    const showAllFormsPayload = this.showAllForms ? this.showAllForms : this.viewForms;
    showAllFormsPayload.map(item => {
      return Object.assign(item, { editMode: true, disabled: true, formData: { }});
    });

    this.editForms.map(item => {
      return Object.assign(item, { editMode: true, formData: { }});
    });
    /* Show modal in edit mode and perform add/update functionality */
    this.performActionInEditMode();

  }

  /**
   * Edit card in pop up mode
   */
  editModal() {
    this.isEditMode =  true;
    const showAllFormsPayload = this.showAllForms ? this.showAllForms : this.viewForms;
    showAllFormsPayload.map(item => {
      return Object.assign(item, { editMode: true, disabled: true, formData: { }});
    });

    this.editForms.map(item => {
      return Object.assign(item, { editMode: true, formData: { }});
    });

    if (this.isEditMode && this.permitPanCancerWrite) {
      this.modalLoader.popupModal(PlaceholderModalComponent, PlaceholderModalLoaderPayload.builder()
        .setComponentToLoad(PanCancerDynamicFormModalComponent)
        .setTitle(this.payload.name)
        .setBackdropAllowed(false)
        .setCssClasses('fixed-size-modal-container-edit ')
        .setPayload({ formsPayload: this.editForms, isEditMode: this.isEditMode, buttonSubmitted: this.buttonSubmitted,
          channelName: this.ModalLoaderTunnelNameEdit,
        })
        .setApproveButton('Update')
        .setApproveCallback(this.onModelSubmitted.bind(this))
        .setDeclineButton('Cancel'), ModalTypes.CUSTOM).pipe(finalize(() => {
        this.isEditMode = false;
      }))
        .subscribe(data => {
          // console.log(data);
        });
    }

  }

  contextLaunch(action: any) {
    if(has(action, 'dataBinding')){
      let dataBinding: [IQueryParam] = get(action, 'dataBinding');
      this.timelineService.launchContextURL(false, dataBinding);
    }
  }

  showOrHideEventIcon(action: any, value: any = undefined) {
    if(has(action, 'dataBinding')) {
      const dataBinding: [IQueryParam] = get(action, 'dataBinding');
      if(dataBinding && dataBinding[0] && dataBinding[0].identifier) {
      const querySubscription = this._agregationService.registerQuery(dataBinding).take(1).subscribe(bundleResult => {
        if(bundleResult && bundleResult[0]){
          this.eventData = get(bundleResult[0], dataBinding[0].identifier);

          if(!isEmpty(this.eventData) && this.eventData != undefined){
            action.hideIcon = false;
          } else{
            action.hideIcon = true;
          }
        }
        if (querySubscription) {
          querySubscription.unsubscribe();
        }
      });
     }
    }
  }

  navigateToEvent(eventData: any) {
    if(Array.isArray(eventData)){
      this._eventService.setSelectedEvent(eventData[0]);
    } else {
      this._eventService.setSelectedEvent(eventData);
    }
    this.goToState('/Pancancer/' + this.patientId + '/reports', this.routerManagerService.queryParameters);
  }

  goToState(redirectUrl, param = {}, isNewTab = false) {
      const interpolatedParamsFromUrl = this._interpolateService.interpolate(redirectUrl, param);
    if (isNewTab) {
      const url = window.document.location.origin + interpolatedParamsFromUrl;
      window.open(url, '_blank');
    } else {
      const redirectUrlState = this._routerManagerService.urlToState(interpolatedParamsFromUrl);
      this.router.navigate([redirectUrlState.name], {queryParams: redirectUrlState.params});
    }

  }

  /**
   * Show card in pop up mode
   */
  showAllModal() {
    const showAllFormsPayload = this.showAllForms ? this.showAllForms : this.viewForms;
    showAllFormsPayload.map(item => {
      return Object.assign(item, { editMode: true, disabled: true, formData: { }});
    });
    if(this.editForms) {
      this.editForms.map(item => {
        return Object.assign(item, {editMode: true, formData: {}});
      });
    }
    this.modalLoader.popupModal(PlaceholderModalComponent, PlaceholderModalLoaderPayload.builder()
      .setComponentToLoad(PanCancerDynamicFormModalComponent)
      .setTitle(this.payload.name)
      .setCssClasses('fixed-size-modal-container ')
      .setPayload({
        showEditIcon: this.permitPanCancerWrite && this.editForms,
        formsPayload: showAllFormsPayload,
        channelName: this.ModalLoaderTunnelName
      }), ModalTypes.CUSTOM).pipe(finalize(() => {
      // Show modal in edit mode and perform add/update functionality
      this.performActionInEditMode();
    })).subscribe(data => {
      if (parseInt(data.payload.toString(), 10) === 4) {
        this.isEditMode = true;
      }
    });
  }

  /**
   * Show modal in edit mode and perform add/update functionality
   */

  performActionInEditMode(){
    if (this.isEditMode && this.permitPanCancerWrite) {
      this.modalLoader.popupModal(PlaceholderModalComponent, PlaceholderModalLoaderPayload.builder()
        .setComponentToLoad(PanCancerDynamicFormModalComponent)
        .setTitle(this.payload.name)
        .setBackdropAllowed(false)
        .setCssClasses('fixed-size-modal-container-edit ')
        .setPayload({ formsPayload: this.editForms, isEditMode: this.isEditMode, buttonSubmitted: this.buttonSubmitted,
          channelName: this.ModalLoaderTunnelName,
        })
        .setApproveButton('Update')
        .setApproveCallback(this.onModelSubmitted.bind(this))
        .setDeclineButton('Cancel'), ModalTypes.CUSTOM).pipe(finalize(() => {
        this.isEditMode = false;
      }))
        .subscribe(data => {
          // console.log(data);
        });
    }
  }

  onModelSubmitted(result) {
    if (result) {
      this.buttonSubmitted = result;
    }
  }

  onCountEmit(value){
    this.showAllDataCountValue=value;
  }
  buildFormConfigurationFromFields(): void {
    if (!isEmpty(get(this.payload, 'widgetPayload.editForms'))) {
      this.editFormIdOrConfig = this.payload.widgetPayload.editForms[0]['formId'];
    }

    // PREPARE SHOW ALL
    if (this.payload.widgetPayload.showAllForms) {
      if (this.payload.widgetPayload.showAllForms.length > 1) {
        this.showFormIdOrConfig = [];
        this.payload.widgetPayload.showAllForms.forEach(field => {
          this._formHandler.getForm(field['formId']);
          this.showFormIdOrConfig.push(
            DynamicFormItem.builder('', field['formId'], ITEMS_TYPES.WIDGET)
              .setComponentToLoad('DynamicFormComponent')
              .setRequired(false)
              .setWidgetPayload({ formId: field['formId'], formItemFullWidth: true}));
        });
      } else if (this.payload.widgetPayload.showAllForms.length > 0) {
        this.showFormIdOrConfig = this.payload.widgetPayload.showAllForms[0]['formId'];
      }
    }
  }

  /**
   * Get form config and update show count
   * @param formID
   */
  resolveFormById(formID: string) {
    this._formHandler.getStoredFormConfigs().pipe(
      map(formConfigs => {
        if (formConfigs.has(formID)) {
          return formConfigs.get(formID);
        } else {
          this._formHandler.getForm(formID);
          return null;
        }
      }),
      filter(config => !!config),
      take(1)
    ).subscribe(_formItems => {
      _formItems = _formItems.filter(input => {
        return !includes(input['cssClass'], 'hidden-form-item');
      });
      /*this.showAllCount += _formItems.length;
      this._showCount = this.getShowAllCount();*/
    });
  }


  dataRecievedEvent(validate: boolean, i) {
    this.dataRecieved[i] = validate;
    this.isdataRecieved = this.dataRecieved.every(item => item);
  }

  navigateToUrl(action) {
    this.goToState(get(action, 'url'), this.routerManagerService.queryParameters, get(action, 'newTab'));
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  // This method receives data from DynamicForm component. It loops though the actions and set the data for each card action.
  dataReceivedForm(cardEvent:any, i){
    let action = get(cardEvent,'action');
    let data = get(cardEvent,'information');
    switch(action) {
      case(CARD_ACTIONS.EVENT_PANEL):
        const index = findIndex(this.actionItems, (action:any) => action.type === CARD_ACTIONS.EVENT_PANEL);
        data.forEach(item => {
          if(get(item,'action') === CARD_ACTIONS.SET_TOOLTIP && index != -1 && get(item,'value')) {
            set(this.actionItems,`${index}.toolTipText`,get(item,'value'));
          }
        });
        break;
    }
  }



}
